<script setup lang="ts">
import type { CondoPropertiesTypology } from '~/core/entities/condo/Condo';
import type { SectionName } from '~/types/mixpanel';

import { CONDO_DETAILS } from '~~/utils/symbols';

import { CondoTalkToAgentButton } from '~/components/condominium/CondoTalkToAgentButton';
import { StandardSlider } from '~/components/StandardSlider';

import { CondoTypologyCard } from '.';

const condominium = inject(CONDO_DETAILS);
const sectionName: SectionName = 'other units';

const otherUnitsLabel = computed(() => {
	return condominium?.value?.exclusiveProperties?.length
		? 'Outras unidades disponíveis'
		: 'Unidades disponíveis';
});
</script>

<template>
	<div>
		<component
			:is="StandardSlider<CondoPropertiesTypology>"
			:items="condominium?.propertiesTypologies"
			:is-loading="!condominium?.propertiesTypologies?.length"
			:section-name="sectionName"
			:slides-to-scroll="2"
			:breakpoints="{
				'(max-width: 640px)': { slidesToScroll: 1 }
			}"
			carousel-item-size="half"
			button-variant="secondary"
			container-class="px-5 pt-0 md:pt-0 md:px-0 lg:px-0"
		>
			<template #header>
				<header class="flex flex-col items-start gap-1 pb-6 md:pb-9">
					<h3
						class="flex items-center font-matter-sq text-2xl font-normal leading-[150%] tracking-[-0.03rem] text-primary md:text-[32px] md:tracking-[-0.64px]"
					>
						{{ otherUnitsLabel }}
					</h3>
					<p class="text-base font-normal leading-[150%] text-primary">
						Compare as opções e consulte um especialista para encontrar a melhor
						escolha.
					</p>
				</header>
			</template>

			<template #items="{ item }">
				<CondoTypologyCard
					:property-typology="item"
					:section-name="sectionName"
				>
					<template #cta>
						<CondoTalkToAgentButton
							:key="item?.companyDistribution"
							:section-name="sectionName"
							:company-distribution="item?.companyDistribution"
							size="sm"
							variant="primary-dark"
							button-classes="h-10 w-[198px] px-3 py-2 text-sm font-medium"
						/>
					</template>
				</CondoTypologyCard>
			</template>
		</component>
	</div>
</template>
